<script>
    import {show_actionCard, close_actionCard} from "../dialogs/OptionDialog.svelte";
    import {executionTxt, protoActions, protoDomains} from "../core.js";

	  // component state variables
    let groupedPowers = $derived(
			Object.groupBy(
				view.character.powers
					.map(powID => protoActions[powID])
					.filter(power => power.TYPE !== 'Ability' && power.execution !== 'passive' && (power.tier > 0 || power.tiers))
        , ({domain}) => domain)  )
    // $inspect(`POWERSTAB - groupedPowers`, groupedPowers)

</script>


<!-------------------------------- HTML -------------------------------------->

<div class="tabContent" data-help="powers">
	{#each Object.keys(groupedPowers) as group}
		<h3 onclick={() => show_actionCard(group.domain.name, 'map', true)}>{protoDomains[group].name ?? group}</h3>
		<table class=powersTable>
			<tbody>
				{#each groupedPowers[group] as power (power.name)}
					<tr id={power.name} class:abil="{power.TYPE === 'Ability'}"
							onmouseover={() => show_actionCard(power.name, 'map')}
							onmouseleave={() => close_actionCard()}
							onclick={() => show_actionCard(power.name, 'map', true)}>
						<td class=textCol>{power.name}</td>
						<td class=textCol>{executionTxt[power.execution]}</td>
						<td class=numberCol>{power.exertion} FP</td>
						<td class=numberCol>{Math.round((power.term <= 3) ? power.term * 12 : power.term)} s</td>
					</tr>
				{/each}
			</tbody>
		</table>
	{:else }
        Der Charakter hat keine Kräfte
	{/each}
</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	.abil
    font-style: italic

	#risk
    width: auto

	#skillPopup
    position: fixed
    z-index: 10
    width: 320px
    height: 180px
    top: calc(50% - 90px)
    left: calc(50% - 160px)
    background: hsl(150, 100%, 10%)
    padding: 0.5em

	#skillPopup .close,
	#actionCard .close
    color: #aaaaaa
    float: right
    font-size: 28px
    font-weight: bold

	#skillPopup .close:hover,
	#skillPopup .close:focus,
	#actionCard .close:hover,
	#actionCard .close:focus
    color: #000
    text-decoration: none
    cursor: pointer

	#skillDiceContainer,
	#abilityButtonBox
    display: flex
    justify-content: space-between
    padding: 16px 16px

</style>